import {Feature} from '../reducers/environmentReducer';
import {FeatureFlag} from '../../../@type/features';
import {getBoundedRecaptchaToken} from '../../../@shared/ts/recaptcha';

export function initBotProtection() {
	if (!Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		return;
	}

	installCaptchaScript();
}

function installCaptchaScript() {
	const script = document.createElement('script');
	script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + Feature.metadata(FeatureFlag.BOT_PROTECTION, 'site_key'));

	script.async = true;
	script.defer = true;

	document.body.appendChild(script);
}

/**
 * Returns a string (recaptcha token or placeholder) that gets appended to form data for captcha validation
 */
export async function getCaptchaToken(): Promise<string> {
	if (!Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		return Promise.resolve('placeholder');
	}

	if (typeof grecaptcha === 'undefined' || typeof grecaptcha.ready !== 'function') {
		console.error('[PP-BotProtection] grecaptcha is not loaded. Verify the reCAPTCHA script is not blocked and the site key is valid.');
		return '';
	}

	const siteKey = Feature.metadata<string>(FeatureFlag.BOT_PROTECTION, 'site_key') ?? '';
	if (!siteKey) {
		console.error('[PP-BotProtection] reCAPTCHA site key is missing in PeachPay settings.');
		return '';
	}

	const token = await getBoundedRecaptchaToken(grecaptcha, {
		siteKey,
		action: 'EXPRESS_CHECKOUT',
		onTimeout() {
			console.error('[PP-BotProtection] reCAPTCHA token generation timed out after 8000ms. The script may be blocked or execute may be stalled.');
		},
		onError(error) {
			console.error('[PP-BotProtection] reCAPTCHA token generation failed.', error);
		},
	});

	return token ?? '';
}
